import { Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import MenuLink from './MenuLink';
import { useLocation, useNavigate } from 'react-router';
import { styled } from '@mui/material/styles';
import { MenuOption, useMatch } from './NavigationHelpers';

const MenuButton = ({
  children,
  options,
  to,
  disableMatch = false,
  dense = false,
  'aria-label': ariaLabel,
}: {
  children: React.ReactNode;
  options?: MenuOption[];
  to?: string;
  disableMatch?: boolean;
  dense?: boolean;
  'aria-label': string;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();
  const match = useMatch({
    location,
    to,
    options,
  });
  const active = !disableMatch && !!match;

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    if (options?.length) {
      setAnchorEl(event.currentTarget);
    } else if (to) {
      navigate('/');
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <MenuLink
        onClick={handleClick}
        arrow={!!options?.length}
        active={active}
        dense={dense}
        aria-label={ariaLabel}
        aria-expanded={open}
        aria-haspopup={!!options?.length}
      >
        {children}
      </MenuLink>
      {options?.length ? (
        <StyledMenu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          role="menu"
        >
          {options.map((option) => {
            const path = 'path' in option ? option.path : undefined;
            const parsedPath = path?.startsWith('/')
              ? path
              : to + '/' + path;
            const onClick =
              'onClick' in option ? option.onClick : undefined;
            const key = 'key' in option ? option.key : path;
            const label = 'label' in option ? option.label : key;

            return (
              <MenuItem
                key={key || path}
                onClick={() => {
                  if (onClick) {
                    onClick();
                  } else if (parsedPath) {
                    navigate(parsedPath);
                  }
                  handleClose();
                }}
                role="menuitem"
                aria-label={option.ariaLabel || ariaLabel}
              >
                {label}
              </MenuItem>
            );
          })}
        </StyledMenu>
      ) : null}
    </div>
  );
};

const StyledMenu = styled(Menu)({});

export default MenuButton;
